
<div class="flex flex-col justify-between h-full" *ngIf="documentTypeStates && operationDatesForm">
  <div class="flex flex-col gap-2">
    <form [formGroup]="operationDatesForm">
      <dx-lookup
        [fieldTemplate]="'fieldTemplate'"
        valueExpr="id"
        displayExpr="number"
        [gsResource]="productionOrderResource"
        formField
        required
        formControlName="productionOrderId">

        <div *dxTemplate="let data of 'fieldTemplate'">
          <div class="hover:underline" (click)="onOperationClick()">
            {{ data?.number }}
          </div>
        </div>
      </dx-lookup>
      <gs-time-span-field
                        [label]="'common.duration' | translate"
                        formField required formControlName="duration"
                        [dates]="{
                        startDate: operation!.startTime,
                        endDate: operation!.endTime
                      }"
      />
      <dx-date-box type="datetime" formField required formControlName="startTime" [label]="'entity.appointment.startActivationDateTime' | translate"/>
      <dx-date-box type="datetime" formField required formControlName="endTime" [label]="'entity.appointment.endActivationDateTime' | translate"/>
    </form>
    <dx-tag-box  *ngIf="workersStore"
      style="margin-bottom: 10px; margin-top: -4px;"
      [gsResource]="workersStore"
      [label]="'menu.breadcrumb.workers' | translate"
      valueExpr="id"
      displayExpr="name"
      itemTemplate="customItem"
      [(value)]="workersOfSelectedOperation">
      <div class="relative" *dxTemplate="let data of 'customItem'">
        <span class="ml-2">{{ data.name }}</span>
        <div *ngIf="!data.isFree" style="width: 20px; height: 20px; align-self: center; background-color: #ea5c3b; position: absolute; top: 13px; left: 270px;" class=" rounded-full"></div>
        <div *ngIf="data.isFree"  style="width: 20px; height: 20px; align-self: center; background-color: #86c285; position: absolute; top: 13px; left: 270px;" class=" rounded-full"></div>
      </div>
    </dx-tag-box>
   <dx-select-box [label]="'common.state' | translate" [items]="documentTypeStates" displayExpr="name"  valueExpr="id" [(value)]="documentTypeState"></dx-select-box>
  </div>
  <div class="mt-3 text-right flex justify-between">
    <div>
      <dx-button id="move" style="position: absolute; z-index: 100; bottom: 26px;color:#28a073;" (onClick)="moveTicket()" [icon]="'arrow_forward'"></dx-button>
      <dx-tooltip
      target="#move"
      showEvent="mouseenter"
      hideEvent="mouseleave"
      [hideOnOutsideClick]="false"
    >
      <div *dxTemplate="let data = data; of: 'content'"> {{'common.moveToFolowingWeek' | translate | ucfirst}} </div>
    </dx-tooltip>
    </div>
    <dx-button
    (onClick)="save()"
    [type]="'default'"
    [icon]="'done'"
    [text]="'common.save' | translate | ucfirst"
  ></dx-button>
  </div>
</div>
